import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Chip,
  Button,
} from '@mui/material';
import { Menu as MenuIcon, Flight, Logout } from '@mui/icons-material';
import { useProcess } from '../contexts/ProcessContext';
import { useAuth } from '../contexts/AuthContext';

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const { status } = useProcess();
  const { user, logout } = useAuth();

  const getStatusChip = () => {
    if (status.running) {
      return (
        <Chip
          label={status.current_step || 'Processing...'}
          color="warning"
          variant="outlined"
          size="small"
        />
      );
    }
    if (status.error) {
      return (
        <Chip
          label="Error"
          color="error"
          variant="outlined"
          size="small"
        />
      );
    }
    if (status.done) {
      return (
        <Chip
          label="Complete"
          color="success"
          variant="outlined"
          size="small"
        />
      );
    }
    return null;
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: 'white',
        color: 'text.primary',
        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      <Toolbar>
        <IconButton
          edge="start"
          onClick={onMenuClick}
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        
        <Flight sx={{ mr: 2, color: 'primary.main' }} />
        
        <Typography
          variant="h6"
          component="div"
          sx={{ 
            flexGrow: 1,
            fontWeight: 600,
            color: 'primary.main'
          }}
        >
          PowerComply - Compliance Analysis powered by AI
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {getStatusChip()}
          
          <Chip
            label={user?.username || 'User'}
            color="primary"
            variant="outlined"
            size="small"
          />
          
          <Button
            onClick={logout}
            startIcon={<Logout />}
            size="small"
            variant="outlined"
            color="inherit"
            sx={{ textTransform: 'none' }}
          >
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;